import { render, staticRenderFns } from "./WanatelPriceModal.vue?vue&type=template&id=c6109510&"
import script from "./WanatelPriceModal.vue?vue&type=script&lang=js&"
export * from "./WanatelPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports